import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import GrayButton from "../../../../components/UI/buttonUI/GrayButton";
import CustomInput from "../../../../components/UI/PageInput/CustomInput";
import SearchDropdown from "../../../../components/UI/PageInput/SearchDropdown";
import SiteViewDialog from "../../dialog/SiteViewDialog";
import { RefreshCcw } from "lucide-react";
import PrimaryButton from "../../../../components/UI/buttonUI/PrimaryButton";
import { UPDATE_SITE } from "../../apiEndpoints";
import usePostData from "../../../../CustomHooks/useAxios/usePostData";
import ErrorDisplay from "../../../../components/UI/ErrorDisplay";
import CenteredHeading from "../../../../components/UI/headingsUI/CenteredHeading";

const UpdateSiteForm = ({ siteSetup }) => {
  const { siteId, siteName, categoryId, jnFtId, jbccFtId, jeId, machineId } =
    useParams();
  const { register, handleSubmit, setValue, watch, control, reset } = useForm({
    defaultValues: {
      name: siteName,
      categoryId: parseInt(categoryId),
      jnFtId: parseInt(jnFtId),
      jbccFtId: parseInt(jbccFtId),
      jeId: parseInt(jeId),
      machineId: machineId === "null" ? "" : parseInt(machineId),
    },
  });

  const {
    executePost,
    loading,
    formError,
    successResponse,
    setFormError,
    setSuccessResponse,
  } = usePostData();

  const onSubmit = (data) => {
    if (data.machineId === "Remove Machine") {
      delete data.machineId;
      data.removeMachine = true;
    }
    executePost(data, UPDATE_SITE + siteId, reset);
  };

  const unAssignedMachines = [
    { id: "Remove Machine" },
    ...siteSetup.machines.filter(
      (machine) => !machine.isAssigned || machine.id === parseInt(machineId),
    ),
  ];

  return (
    <div className="form-container">
      <CenteredHeading title="Update Site" />
      {formError && (
        <ErrorDisplay
          message={formError}
          closeAction={() => setFormError("")}
        />
      )}
      <form
        onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
        className="form-border max-w-5xl mx-auto w-95% form-border"
      >
        <div className="flex flex-wrap">
          <div className="inputLeftCol">
            <CustomInput
              type="text"
              name="name"
              labelText="Update Site Name"
              placeholder="Enter"
              register={{
                ...register("name", {
                  validate: (value) => {
                    if (value.trim() === "") {
                      return "Site Name cannot contain only spaces";
                    }
                    return true;
                  },
                }),
              }}
              disableValidationMessage={false}
            />
          </div>
          <div className="inputRightCol">
            <SearchDropdown
              name="categoryId"
              label="Site Category"
              keyName="name"
              id="id"
              options={siteSetup.categories}
              setValue={setValue}
              control={control}
              selectedVal={watch("categoryId")}
              search={true}
              disableValidationMessage={false}
            />
          </div>
          <div className="inputLeftCol">
            <SearchDropdown
              name="jnFtId"
              label="Field Technician (JN)"
              keyName="fullName"
              id="id"
              options={siteSetup.jnFieldTechnicians}
              setValue={setValue}
              control={control}
              selectedVal={watch("jnFtId")}
              disableValidationMessage={false}
              search={true}
            />
          </div>
          <div className="inputRightCol">
            <SearchDropdown
              name="jbccFtId"
              label="Field Technician (JBCC)"
              keyName="fullName"
              id="id"
              options={siteSetup.jbccFieldTechnicians}
              setValue={setValue}
              control={control}
              selectedVal={watch("jbccFtId")}
              disableValidationMessage={false}
              search={true}
            />
          </div>
          <div className="inputLeftCol">
            <SearchDropdown
              name="jeId"
              label="JE Name *"
              keyName="name"
              id="id"
              options={siteSetup.jes}
              setValue={setValue}
              control={control}
              selectedVal={watch("jeId")}
              disableValidationMessage={false}
              search={true}
              showOptionId={true}
            />
          </div>
          <div className="inputRightCol">
            <SearchDropdown
              name="machineId"
              label="Machine Id"
              keyName="id"
              id="id"
              options={unAssignedMachines}
              setValue={setValue}
              control={control}
              selectedVal={watch("machineId")}
              disableValidationMessage={false}
              search={true}
            />
          </div>
        </div>
        <div className="addBtn---wrap">
          <p className="addWrap">
            <PrimaryButton
              btnText={!loading ? "Update Site" : "Updating..."}
              loading={loading}
              Icon={RefreshCcw}
              size={18}
            />
          </p>
          <p className="grayWrap">
            <GrayButton btnText="Clear" onClick={() => reset()} />
          </p>
        </div>
      </form>
      {successResponse && (
        <SiteViewDialog
          viewDetails={successResponse}
          successView={true}
          setSiteViewDetails={setSuccessResponse}
          successMsg="Site Successfully Updated!"
        />
      )}
    </div>
  );
};
export default UpdateSiteForm;
